var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExclamationPoint(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    rx: 9,
    fill: "currentColor"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.875 4.5C7.875 3.87868 8.37868 3.375 9 3.375C9.62132 3.375 10.125 3.87868 10.125 4.5V10.125C10.125 10.7463 9.62132 11.25 9 11.25C8.37868 11.25 7.875 10.7463 7.875 10.125V4.5Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.875 13.5C7.875 12.8787 8.37868 12.375 9 12.375C9.62132 12.375 10.125 12.8787 10.125 13.5C10.125 14.1213 9.62132 14.625 9 14.625C8.37868 14.625 7.875 14.1213 7.875 13.5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExclamationPoint);
export default __webpack_public_path__ + "static/media/exclamation-point.df0b922c4a463366f3864667df6407a3.svg";
export { ForwardRef as ReactComponent };